/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Feature_Privacy_TitleInputs */

const en_landing_feature_privacy_title = /** @type {(inputs: Landing_Feature_Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy-First Controls`)
};

const de_landing_feature_privacy_title = /** @type {(inputs: Landing_Feature_Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy-First-Kontrollen`)
};

const fr_landing_feature_privacy_title = /** @type {(inputs: Landing_Feature_Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confidentialite dabord`)
};

const es_landing_feature_privacy_title = /** @type {(inputs: Landing_Feature_Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacidad primero`)
};

const it_landing_feature_privacy_title = /** @type {(inputs: Landing_Feature_Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy-First`)
};

const nl_landing_feature_privacy_title = /** @type {(inputs: Landing_Feature_Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy-First`)
};

const pl_landing_feature_privacy_title = /** @type {(inputs: Landing_Feature_Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prywatnosc przede wszystkim`)
};

const fi_landing_feature_privacy_title = /** @type {(inputs: Landing_Feature_Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yksityisyys ensin`)
};

const da_landing_feature_privacy_title = /** @type {(inputs: Landing_Feature_Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy-First`)
};

const sv_landing_feature_privacy_title = /** @type {(inputs: Landing_Feature_Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sekretess foerst`)
};

/**
* | output |
* | --- |
* | "Privacy-First Controls" |
*
* @param {Landing_Feature_Privacy_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_feature_privacy_title = /** @type {((inputs?: Landing_Feature_Privacy_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Feature_Privacy_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_feature_privacy_title(inputs)
	if (locale === "fr") return fr_landing_feature_privacy_title(inputs)
	if (locale === "es") return es_landing_feature_privacy_title(inputs)
	if (locale === "it") return it_landing_feature_privacy_title(inputs)
	if (locale === "nl") return nl_landing_feature_privacy_title(inputs)
	if (locale === "pl") return pl_landing_feature_privacy_title(inputs)
	if (locale === "fi") return fi_landing_feature_privacy_title(inputs)
	if (locale === "da") return da_landing_feature_privacy_title(inputs)
	if (locale === "sv") return sv_landing_feature_privacy_title(inputs)
	return en_landing_feature_privacy_title(inputs)
});